@if (dateTypesAvailable && dateTypesAvailable.length > 0) {
<div [formGroup]="formGroup" class="d-flex gap">
    <mat-form-field appearance="outline" class="mat-form-field full-width">
        <mat-label>
            {{ 'customer.newAnimal.dropdown.dateType' | translate }}
        </mat-label>
        <mat-select formControlName="dateType" [id]="'somDateType' + index">
            @for (date of generateDropdown(); track date) {
            <mat-option [value]="date" [id]="'spnOption' + date.name">
                {{ date.name }}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="display-block full-width">
        <mat-label>{{'customer.newAnimal.input.date' | translate}}</mat-label>
        <input matInput [id]="'intDate' + index" mbsc-datepicker [controls]="['date']" [max]="maxDate" formControlName="date"
            themeVariant="light" theme="material" display="anchored" [touchUi]="true"
            [cancelText]="'appointment.edit.timepicker.cancel' | translate" [buttons]="['set', 'cancel']"
            [setText]="'general.label.yes' | translate" dateFormat="DD.MM.YYYY" returnFormat="jsdate"
            [locale]="localeDatePicker" />
        <mat-icon matSuffix>
            calendar_today
        </mat-icon>
    </mat-form-field>
</div>
}